module.exports = __webpack_public_path__ + "media/images/dummy_item1-ae50c5845dd3d024fcf0dc7e4ddd3875.jpeg";